import {
  ETextStyleVariant,
  GeneralHeartFilledIcon,
  GeneralHeartUnfilledIcon,
  RawButton,
  Text,
} from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import { WishlistModalWrapper } from '@/components/wishlists/WishlistModal';
import { IWishlistingEventData } from '@/services/analytics/listings/types';
import { TAutoRentalTile } from '@/utility/mapAutoSearchResultToTile';
import { ISearchResultTile } from '@/utility/mapSearchResultToTile';

type TListingTileFavoriteToggleProps = {
  listingTile: ISearchResultTile | TAutoRentalTile;
  wishlistingEventData?: IWishlistingEventData;
};

export const ListingTileFavoriteToggle = ({
  listingTile,
  wishlistingEventData,
}: TListingTileFavoriteToggleProps) => {
  if (listingTile.loading) return null;

  const { isFavorite, favoriteCount } = listingTile;

  return (
    <WishlistModalWrapper
      rental={listingTile}
      isFavorite={isFavorite}
      wishlistingEventData={wishlistingEventData}
      TriggerComponent={({ toggleFavorite }) => (
        <FavoriteButton
          isFavorite={isFavorite}
          favoriteCount={favoriteCount}
          onClick={toggleFavorite}
        />
      )}
    />
  );
};

type TFavoriteButton = {
  isFavorite?: boolean;
  favoriteCount?: number;
  onClick: () => void;
};

const FavoriteButton = ({ isFavorite, favoriteCount = 0, onClick }: TFavoriteButton) => {
  const intl = useIntl();

  return (
    <RawButton
      onPress={onClick}
      onClickCapture={e => e.preventDefault()}
      aria-label={
        isFavorite
          ? intl.formatMessage({ defaultMessage: 'Saved', id: 'fsB/4p' })
          : intl.formatMessage({ defaultMessage: 'Click to save', id: 'q+y0s3' })
      }>
      <div className="flex items-center text-white gap-1 flex-nowrap">
        {favoriteCount > 0 && (
          <Text component="div" variant={ETextStyleVariant.LargeRegular}>
            {favoriteCount > 999
              ? intl.formatMessage({ defaultMessage: '1K+', id: 'dAHibN' })
              : favoriteCount}
          </Text>
        )}

        <div className="relative w-7 h-7">
          <GeneralHeartFilledIcon
            className={cn('text-gray-800 w-full h-full', {
              'opacity-30': !isFavorite,
            })}
          />

          <GeneralHeartUnfilledIcon className="absolute inset-0 w-full h-full" />
        </div>
      </div>
    </RawButton>
  );
};
